// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Search from "@insite/mobius/Icons/Search";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { buttonGetFieldIconProps } from "@store/Themes/common/props/button";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { FC, useEffect, useState, HTMLAttributes } from "react";

export interface QuickSearchFieldPresentationProps extends ExpandStyles<QuickSearchFieldStyles> {}

export interface QuickSearchFieldProps extends QuickSearchFieldPresentationProps, HTMLAttributes<HTMLInputElement> {
    placeholder: string;
    initialValue?: string;
    onSearch: (value: string) => void;
}

export interface QuickSearchFieldStyles {
    textField?: TextFieldPresentationProps;
}

export const quickSearchFieldStyles: QuickSearchFieldStyles = {
    textField: {
        sizeVariant: "xsmall" as any,
        ...buttonGetFieldIconProps(Search),
    },
};

const QuickSearchField: FC<QuickSearchFieldProps> = ({
    extendedStyles,
    overridedStyles,
    placeholder,
    initialValue = "",
    onSearch,
    ...htmlAttributes
}) => {
    const styles = useExpandProps(quickSearchFieldStyles, extendedStyles, overridedStyles);
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        setValue(initialValue ?? "");
    }, [initialValue]);

    const handleSearch = () => {
        onSearch(value);
    };

    return (
        <TextField
            {...styles.textField}
            label={translate("Quick Search")}
            value={value}
            placeholder={placeholder}
            data-test-selector="quickSearch_input"
            onChange={e => setValue(e.currentTarget.value)}
            onKeyDown={e => {
                if (e.key === "Enter") {
                    handleSearch();
                }
            }}
            iconClickableProps={{
                ...styles.textField?.iconClickableProps,
                onClick: handleSearch,
                "aria-label": translate("Search"),
            }}
            clickableText={translate("Search")}
            {...htmlAttributes}
        />
    );
};

export default QuickSearchField;
